import React, { Dispatch, SetStateAction, useRef, useState } from 'react'
import {
  RectangleStencil,
  ImageRestriction,
  Priority,
  FixedCropperRef,
  FixedCropper,
} from 'react-advanced-cropper'
import 'react-advanced-cropper/dist/style.css'
import { Container } from '@nextui-org/react'

import FanmeLoading from '@/components/atoms/FanmeLoading'
import MuiButton from '@/components/atoms/MuiButton'
import { Gradation } from '@/constants/styles/color'
import { useToast } from '@/contexts/ToastContext'
import { putForm } from '@/pages/api/base'
import styles from './TrimmingHeaderImage.module.scss'

interface Props {
  img: string
  aspectRatio: number
  setTrimModal?: Dispatch<SetStateAction<boolean>>
  setSelectedHeaderImage?: Dispatch<SetStateAction<HTMLCanvasElement | undefined>>
  cancel: () => void
}

const TrimmingHeaderImageContainer = ({
  img,
  aspectRatio,
  setTrimModal,
  setSelectedHeaderImage,
  cancel,
}: Props) => {
  const [image] = useState(img)

  const cropperRef = useRef<FixedCropperRef>(null)

  const [isLoading, setIsLoading] = useState(false)

  const { headerToast } = useToast()

  const [canvasData, setCanvasData] = useState<HTMLCanvasElement>()

  const updateHeader = async (form: FormData) => {
    const url = '/creators/self/profile/header_image'
    try {
      const response = await putForm(url, form)
      if (response.status === 200) {
        setIsLoading(false)
        setTrimModal!(false)
        setSelectedHeaderImage && setSelectedHeaderImage(canvasData /* .toDataURL() */)
        headerToast.setVisible(true)
        setTimeout(() => {
          headerToast.setVisible(false)
        }, 1500)
      }
    } catch (e) {
      // TODO Error handling
      setIsLoading(false)
    }
  }

  const uploadImage = async () => {
    setIsLoading(true)
    const canvas = cropperRef.current?.getCanvas()
    if (canvas) {
      const form = new FormData()
      canvas.toBlob(blob => {
        if (!blob) {
          setIsLoading(false)
          return
        } else {
          form.append('header_image', blob)
          updateHeader(form)
        }
      }, 'image/png')
      setSelectedHeaderImage && setSelectedHeaderImage(canvas)
    } else {
      setIsLoading(false)
    }
  }

  return (
    <>
      {isLoading && <FanmeLoading />}
      <Container
        css={{
          height: '100%',
          maxWidth: '100%',
          margin: 0,
          padding: 0,
          position: 'fixed',
          zIndex: '10001',
          top: 0,
          left: 0,
        }}
      >
        <FixedCropper
          style={{
            width: '100%',
            height: '100%',
            background: Gradation.PT_30,
          }}
          src={image}
          imageRestriction={ImageRestriction.stencil}
          stencilComponent={RectangleStencil}
          stencilSize={{ width: screen.width, height: screen.width / aspectRatio }}
          stencilProps={{
            handlers: {},
            movable: true,
            resizable: false,
            previewClassName: styles.line,
          }}
          priority={Priority.coordinates}
          ref={cropperRef}
        />
        <Container
          css={{
            d: 'flex',
            jc: 'space-between',
            position: 'absolute',
            top: '24px',
            p: '0 24px',
          }}
        >
          <MuiButton onClick={cancel} text="キャンセル" size="sm" width="96px" shadow />
          <MuiButton
            text="アップロード"
            size="sm"
            width="96px"
            colored
            shadow
            onClick={uploadImage}
          />
        </Container>
      </Container>
    </>
  )
}

export default TrimmingHeaderImageContainer
